<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FooterCopyright },
	data() {
		return {
			socials: socialLinks,
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<div class="container mx-auto">
		<div
			class="pt-20 sm:pt-30 pb-8 mt-20 border-t border-gray-200 dark:border-gray-800"
		>
			<!-- Footer social links -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-20"
			>
				<p
					class="font-general-semibold text-3xl sm:text-4xl font-semibold text-primary-dark dark:text-primary-light mb-8 sm:mb-10"
				>
					Let's Connect
				</p>
				<ul class="flex gap-6 sm:gap-8">
					<a
						v-for="social in socials"
						:key="social.id"
						:href="social.url"
						target="__blank"
						class="social-icon-container group"
					>
						<i
							:data-feather="social.icon"
							class="w-6 sm:w-7 h-6 sm:h-7 transition-transform duration-300 group-hover:scale-110"
						></i>
					</a>
				</ul>
			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
		</div>
	</div>
</template>

<style scoped>
.social-icon-container {
	@apply relative flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-lg;
	@apply bg-gray-50 dark:bg-gray-800;
	@apply border border-gray-200 dark:border-gray-700;
	@apply text-gray-500 dark:text-gray-400;
	@apply transition-colors duration-300;
}

.social-icon-container:hover {
	@apply border-gray-400 dark:border-gray-500;
	@apply text-black dark:text-white;
	@apply bg-gray-100 dark:bg-gray-700;
}
</style>
